/**
 *
 * @component 用户中心/我的消息/互动消息----互动消息tab
 *
 **/

import { Pagination } from 'antd';
import { forwardRef, useImperativeHandle } from 'react';
import BaseListWrap from '&/components/BaseListWrap';
import { useStoreState } from '&/utils/customHooks';
import useMessage from '@/utils/customHooks/useMessage';
import MessageItem from '@/components/UserCenter/MessageItem';
import { useRouterTarget } from '&/utils/customHooks';
import { SYNERGIA_TAB_STATUS } from '&/utils/baseMacro';
import './InteractiveMsg.scss';

const InteractiveMsg = forwardRef((props, ref) => {
    const persenCenter = useStoreState('persenCenter');
    const { organization = {} } = useStoreState('appStore');
    const [
        msgList,
        loading,
        total,
        queryForm,
        onPageChange,
        deleteMsg,
        markAsRead,
    ] = useMessage(1, persenCenter.queryUnreadAmount, persenCenter.forceUpdate);

    useImperativeHandle(ref, () => {
        return { markAsRead };
    });

    const targetPage = useRouterTarget();

    // 点击查看
    const targetTo = params => {
        let jumpText = intl.get('userCenter.clickHere');

        if (params.url) {
            return (
                <a className="native-link" href={params.url}>
                    {jumpText}
                </a>
            );
        }
        const PROJECT_URL = '/user-center/project-space/scheme-detail',
            { PLANS, DRAWING } = SYNERGIA_TAB_STATUS,
            { pageTarget } = params;

        switch (pageTarget) {
            case 'order': // 会员开通/付款提醒/订单关闭：跳转订单详情
                jumpText = intl.get('base.viewDetail');
                break;
            case 'software': // 会员续费: 跳转智能设计订单
                return;
            /* jumpText = intl.get('userCenter.renew');
                break; */
            default:
                break;
        }

        const targetMethods = {
            order() {
                // 会员开通/付款提醒/订单关闭：跳转订单详情
                const { type } = params;
                const FOLDERS = ['intelligent-design', 'cloud-services'];
                targetPage({
                    pathname: `/user-center/${FOLDERS[type]}/order-detail`,
                    search: { type, id: params.orderCode },
                });
            },
            // 会员续费: 跳转智能设计订单
            // 目前企业版已删除  智能设计订单 页面  @see HDC-5881
            /*  software() {
                targetPage({
                    pathname: '/user-center/intelligent-design',
                    search: {
                        subscribe: 1,
                    },
                }); 
            },*/
            project() {
                // 项目开通/项目续费:跳转项目详情
                const { div } = params;
                const FOLDERS = ['project-detail', 'scheme-detail'];
                const TABS = [2, SYNERGIA_TAB_STATUS.INFO];
                targetPage({
                    pathname: `/user-center/project-space/${FOLDERS[div - 1]}`,
                    search: {
                        id: params.projectId,
                        tab: TABS[div - 1],
                    },
                });
            },
            projectMemberList() {
                // 项目成员列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: SYNERGIA_TAB_STATUS.MEMBERS,
                    },
                });
            },
            projectDrawing() {
                //  指定的项目施工图
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.project_id,
                        tab: DRAWING,
                        drawing_id: params.drawing_id,
                    },
                });
            },
            projectDrawingIndex() {
                //  项目施工图tab页
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.project_id,
                        tab: DRAWING,
                    },
                });
            },
            modelDetailWeb() {
                // 模型详情
                targetPage(`/model-base/material-detail/${params.modelId}`);
            },
            schedule() {
                // 进度计划列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                    },
                });
            },
            stageDetail() {
                // 【施工阶段】详情
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'DETAIL',
                    },
                });
            },
            stageCheck() {
                // 施工阶段 验收
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'CHECK',
                    },
                });
            },
            decoration() {
                // 装修待办列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'DECORATION',
                    },
                });
            },
            adjunct() {
                // 附件列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        drawer: 'ADJUNCT',
                    },
                });
            },
            additional() {
                // 增项列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        drawer: 'ADDITIONAL',
                    },
                });
            },
            patrol() {
                // 巡检列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'PATROL',
                    },
                });
            },
            moments() {
                // 施工动态列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'MOMENTS',
                    },
                });
            },
            projectCheck() {
                // 项目验收
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: -1,
                        drawer: 'CHECK',
                    },
                });
            },
            fund() {
                // 项目款项tab
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: SYNERGIA_TAB_STATUS.PAYMENT,
                    },
                });
            },
            organization() {
                // 组织架构
                targetPage({
                    pathname: '/user-center/organization',
                    search: {
                        entId: params.entId,
                        depId: params.depId,
                    },
                });
            },
        };
        const fn = targetMethods[params.pageTarget] || null;
        return (
            fn && (
                <a className="native-link" onClick={fn}>
                    {jumpText}
                </a>
            )
        );
    };

    const messageTarget = data => {
        if (!data.param1) return;
        const PARAMS = JSON.parse(data.param1);
        if (!PARAMS) return;
        return targetTo(PARAMS);
    };

    return (
        <BaseListWrap
            className="interactive-msg"
            isLoading={loading}
            isEmpty={!!msgList.length}>
            {msgList.map(e => (
                <>
                    {e.isHeader && <div className="date-title">{e.day}</div>}
                    <MessageItem
                        key={e.id}
                        data={e}
                        onClick={() => {
                            markAsRead([e.id], e.status);
                        }}
                        disabled={
                            organization.example === 0 &&
                            organization.roleFlag !== 'admin'
                        }
                        content={
                            <>
                                {e.content
                                    .replace(
                                        intl.get('userCenter.clickHere'),
                                        ''
                                    )
                                    .replace(
                                        intl.get('userCenter.clickDetail'),
                                        ''
                                    )}
                                {messageTarget(e)}
                            </>
                        }
                        deleteMsg={deleteMsg}
                    />
                </>
            ))}
            <Pagination
                size="small"
                current={queryForm.page}
                onChange={onPageChange}
                pageSize={queryForm.limit}
                total={total}
                showSizeChanger={true}
                showTotal={total => intl.get('base.total', { total })}
            />
        </BaseListWrap>
    );
});
export default InteractiveMsg;
